import React, { useEffect, useRef, useState } from 'react';
import { ImCross } from "react-icons/im";
import { FaRegStar, FaChargingStation, FaDirections, FaParking, FaClock } from "react-icons/fa";
import { MdOutlinePriceCheck } from "react-icons/md";
import { IoIosInformationCircle } from "react-icons/io";
import chargerIcon from '../img/charger.svg';
import Modal from 'react-modal';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '../css/tabMenu.css';
import '../css/map.css';
import PlacesMap from '../geojson/map.geojson';

Modal.setAppElement('#root');

//Pintar ciurculos en el mapa
const size = 100;
const pulsingDot = {
    width: size,
    height: size,
    data: new Uint8Array(size * size * 4),

    onAdd: function () {
        const canvas = document.createElement('canvas');
        canvas.width = this.width;
        canvas.height = this.height;
        this.context = canvas.getContext('2d');
    },

    render: function () {
        const duration = 3000;
        const t = (performance.now() % duration) / duration;

        const radius = (size / 2) * 0.3;
        const outerRadius = (size / 2) * 0.7 * t + radius;
        const context = this.context;

        context.clearRect(0, 0, this.width, this.height);
        context.beginPath();
        context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2
        );
        context.fillStyle = `rgba(255, 200, 200, ${1 - t})`;
        context.fill();

        context.beginPath();
        context.arc(
            this.width / 2,
            this.height / 2,
            radius,
            0,
            Math.PI * 2
        );
        context.fillStyle = 'rgb(106, 181, 77)';
        context.strokeStyle = 'white';
        context.lineWidth = 2 + 4 * (1 - t);
        context.fill();
        context.stroke();

        this.data = context.getImageData(
            0,
            0,
            this.width,
            this.height
        ).data;

        if (this.map) {
            this.map.triggerRepaint();
        }


        return true;
    }
};

const Mapa3D = () => {
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);
    const currentPopup = useRef(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalDepth, setModalDepth] = useState(1);
    const [modalNombre, setModalNombre] = useState('');
    const [modalDireccion, setModalDireccion] = useState('');
    const [modalValoracion, setModalValoracion] = useState('');
    const [modalComoLlegar, setModalComoLlegar] = useState('');
    const [modalRecarga, setModalRecarga] = useState('');
    const [modalPersonaContacto, setModalPersona] = useState('');
    const [modalCorreoContacto, setModalCorreo] = useState('');
    const [modalCargadores, setModalCargadores] = useState([]);
    const [modalActivo, setModalActivo] = useState('');
    const [modalIframeURLs, setIframeURLs] = useState([]);
    const [showSearchControl, setShowSearchControl] = useState(true);
    const [placesData, setPlacesData] = useState(null);
    const [activeTab, setActiveTab] = useState('cargadores');

    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoibXZpY2VudGVlIiwiYSI6ImNsc2x3dzNzejBodngybHJud2RoaGhhZGIifQ.iol6oKIWDuOuMRlTsN4Gfw';

        const loadMap = () => {
            const map = new mapboxgl.Map({
                container: mapContainerRef.current,
                style: 'mapbox://styles/mvicentee/clsn0kms200ix01qu7relbgpz',
                center: [2.096353, 41.384116],
                zoom: 11.13,
                pitch: 45.00,
                bearing: -7.84,
                antialias: true,
            });

            mapRef.current = map;
            
            setPlacesData(PlacesMap.features);

            map.on('load', () => {
                map.addSource('places', {
                    type: 'geojson',
                    data: PlacesMap
                });
        
                map.addLayer({
                    id: 'places',
                    type: 'circle',
                    source: 'places',
                    paint: {
                        'circle-color': '#6ab54d',
                        'circle-radius': 6,
                        'circle-stroke-width': 2,
                        'circle-stroke-color': '#ffffff'
                    }
                });

                map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 });
                map.addSource('dot-point', {
                    type: 'geojson',
                    data: PlacesMap
                });

                map.addLayer({
                    'id': 'layer-with-pulsing-dot',
                    'type': 'symbol',
                    'source': 'dot-point',
                    'layout': {
                        'icon-image': 'pulsing-dot'
                    }
                });
                
                map.on('mouseenter', 'places', (e) => {
                    map.getCanvas().style.cursor = 'pointer';
                    const coordinates = e.features[0].geometry.coordinates.slice();
                    const nombre = e.features[0].properties.nombre;
                    const direccion = e.features[0].properties.direccion;
        
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }

                    if (currentPopup.current) {
                        currentPopup.current.remove();
                    }

                     currentPopup.current = new mapboxgl.Popup({
                        closeButton: false,
                        closeOnClick: false,
                        className: 'popup'
                    })
                        .setLngLat(coordinates)
                        .setHTML(`<h3>${nombre}</h3>${direccion}`)
                        .addTo(map);               
                });
        
                map.on('mouseleave', 'places', () => {
                    map.getCanvas().style.cursor = '';
                    if (currentPopup.current && !currentPopup.current.fixed) {
                        currentPopup.current.remove();
                    }
                });
        
                map.on('click', 'places', (e) => {
                    if (currentPopup.current) {
                        const popup = currentPopup.current;
                        const popupContent = popup._content;
                        const isFixed = popup.fixed;
                       
                        if (isFixed) {
                            popup.fixed = false;
                            popupContent.classList.remove('popup-large');
                            popupContent.removeChild(popupContent.lastChild);
                        } else {
                            popup.fixed = true;
                            popupContent.classList.add('popup-large');

                           // Contenido del botón "leer más"
                           const { nombre, direccion, comollegar, activo, recarga, valoracion, cargadores, persona, correo, iframeURLs } = e.features[0].properties;
                           const popupHTML = `
                                <div class="popup-header">
                                    <h3>${nombre}</h3>
                                    <span class="popup-close-button">×</span>
                                </div>
                                <p>${activo}</p>
                                <button class="popup-read-more-button">Información</button>
                            `;

                            popupContent.innerHTML = popupHTML;
                            popupContent.querySelector('.popup-read-more-button').addEventListener('click', () => {
                                openModal(nombre, direccion, comollegar, activo, recarga, valoracion, cargadores, persona, correo, iframeURLs);
                            });
                            popupContent.querySelector('.popup-close-button').addEventListener('click', () => {
                                popup.remove();
                            });

                            const content = `
                                Dirección: ${direccion}
                                Valoración: ${valoracion}
                            `;
                            setModalContent(content);
                            setPlacesData(e.features[0].properties);
                        }
                    }
                });
            });
            
            // Añadir control de zoom
            const navigationControl = new mapboxgl.NavigationControl({
                showCompass: false,
                visualizePitch: false
            });
          
            const navControlElement = navigationControl.onAdd(map);
            navControlElement.style.position = 'absolute';
            navControlElement.style.left = '10px';
            navControlElement.style.top = '70px'; 
          
            map.getContainer().appendChild(navControlElement);

             // Buscador mapa
             if (showSearchControl) {
                const searchControl = new MapboxGeocoder({
                    accessToken: mapboxgl.accessToken,
                    mapboxgl: mapboxgl,
                    countries: 'es',
                    bbox: [1.9976, 41.279, 2.3335, 41.4769],
                    proximity: { longitude: 2.154, latitude: 41.3851 },
                    placeholder: "Buscar en Barcelona"
                });
                map.addControl(searchControl, 'top-right');
            } 
        };
        
        // Esperar a que el DOM esté completamente cargado antes de cargar el mapa
        if (document.readyState === 'complete') {
            loadMap();
        } else {
            window.addEventListener('load', loadMap);
        }

        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
            }
            if (currentPopup.current) {
                currentPopup.current.remove();
            }
        };
        
    }, [showSearchControl]); 

    const openModal = (nombre, direccion, comollegar, activo, recarga, valoracion, cargadores, persona, correo, iframeURLs) => { 
        const parsedIframeURLs = typeof iframeURLs === 'string' ? JSON.parse(iframeURLs) : iframeURLs;
        const parsedCargadores = typeof cargadores === 'string' ? JSON.parse(cargadores) : cargadores;       
        setModalNombre(nombre);
        setModalDireccion(direccion);
        setModalComoLlegar(comollegar);
        setModalActivo(activo);
        setModalRecarga(recarga);
        setModalValoracion(valoracion);
        setModalCargadores(Array.isArray(parsedCargadores) ? parsedCargadores : []); 
        setModalPersona(persona);
        setModalCorreo(correo);
        setIframeURLs(Array.isArray(parsedIframeURLs) ? parsedIframeURLs : []);
        setModalIsOpen(true);
        setShowSearchControl(false);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setShowSearchControl(true);
    };

    return (
        <div>
            <div ref={mapContainerRef} className="map-container" />
                <div className="map-overlay">
                    <img src="app/ue.png" alt="Union" className="overlay-image-ue" /> 
                    <img src="app/ue_ministerio.png" alt="Ministerio" className="overlay-image-min" /> 
                </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Leer más"
                style={{ overlay: { zIndex: modalDepth, backgroundColor: 'rgba(0, 0, 0, 0.5)' }, content: { top: '90px'} }}
            >
                <div>
                    <div className="icono-tipo"><FaChargingStation className='icon' />Vía pública</div>
                    <h2 className="popup-title-modal">Electrolinera {modalNombre}</h2>
                    <div className="popup-content">
                        <div className="popup-left">
                            <div className="popup-descriptionModal">
                                <b>Dirección:</b> {modalDireccion}<br />
                            </div>
                            <div className="tab-popup">
                                <button className={activeTab === 'cargadores' ? "tablinks active" : "tablinks"} onClick={() => setActiveTab('cargadores')}>Tipo de cargadores</button>
                                <button className={activeTab === 'informacion' ? "tablinks active" : "tablinks"} onClick={() => setActiveTab('informacion')}>Información General</button>
                            </div>
                            <div id="informacion" className={activeTab === 'informacion' ? "tabcontent-popup active" : "tabcontent-popup"}>
                                {activeTab === 'informacion' && (
                                    <>
                                        <div className="icono-y-texto">
                                            <FaDirections className='icono-info' /><h3> Como llegar</h3>
                                        </div>
                                        <hr className="separator" />
                                        <p className='p-informacion'>{modalComoLlegar}</p>
                                        <div className="icono-y-texto">
                                            <FaParking className='icono-info' /><h3>Aparcamiento</h3>
                                        </div>
                                        <hr className="separator" />
                                        <p className='p-informacion'>Tiene aparcamiento GRATUITO</p>
                                        <div className="icono-y-texto">
                                            <MdOutlinePriceCheck className='icono-info' /><h3>Recarga</h3>
                                        </div>
                                        <hr className="separator" />
                                        <p className='p-informacion'>{modalRecarga}</p>
                                        <div className="icono-y-texto">
                                            <FaClock className='icono-info' /><h3>Horario</h3>
                                        </div>
                                        <hr className="separator" />
                                        <p className='p-informacion'>24/7</p>
                                        <div className="icono-y-texto">
                                            <FaRegStar className='icono-info' /><h3>Valoración</h3> <br />
                                        </div>
                                        <hr className="separator" />
                                        <p className='p-informacion'>{modalValoracion}</p>
                                        <div className="icono-y-texto">
                                            <IoIosInformationCircle className='icono-info' /><h3>Información de contacto</h3>
                                        </div>
                                        <hr className="separator" />
                                        <h5 className='p-informacion'>Persona de contacto</h5>
                                        <p className='p-informacion'>{modalPersonaContacto}</p>
                                        <h5 className='p-informacion'>Correo electrónico de contacto</h5>
                                        <p className='p-informacion'>{modalCorreoContacto}</p>
                                    </>
                                )}
                            </div>
                            <div id="cargadores" className={activeTab === 'cargadores' ? "tabcontent-popup active" : "tabcontent-popup"}>
                                {Array.isArray(modalCargadores) && modalCargadores.length > 0 ? (
                                    modalCargadores.map((cargador, index) => (
                                        <div className="comment-container" key={index}>
                                            <img src={chargerIcon} alt="Charger Icon" style={{ width: '30px', height: '30px', marginRight: '5px' }} />
                                            <span className='info'>{cargador.tipo || 'Tipo desconocido'}</span>
                                            <div className="comment-description">{cargador.descripcion || 'Descripción no disponible'}</div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No hay cargadores disponibles.</p>
                                )}
                            </div>
                        </div>
                        <div className="popup-right">
                            <div className="cargadores-container">
                                {Array.isArray(modalIframeURLs) && modalIframeURLs.length > 0 ? (
                                    modalIframeURLs.map((url, index) => (
                                        <iframe key={index} src={url} title={`Iframe ${index}`} className="responsive-iframe" />
                                    ))
                                ) : (
                                    <p>No hay iframes disponibles.</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <button className="popup-close-buttonModal" onClick={closeModal}><ImCross className='icon' />Cerrar</button>
                </div>
            </Modal>
        </div>
    );
};

export default Mapa3D;
